// Core
import React, { Component } from "react";

// Router
import { $state, $stateParams } from "../../../../router/";

// Logic
import {
  emptyGroup,
  editorGroups,
  filterKey,
  filterSummary,
  groupsToUrl,
  hasActiveFeatureFilter,
  normalizeGroup,
  validGroups,
} from "../../../../Logic/Account/featureFilter";

// Components
import {
  GECKO_CONSTS,
  GeckoBtn,
  GeckoBtnsSorted,
  GeckoCardBody,
  GeckoCardWrapper,
  GeckoIcon,
} from "@geckolabs/gecko-react-ui";

import FeatureFilterRow from "./FeatureFilterRow";

import "./FeatureFilter.css";

function accountsListParams(overrides) {
  return Object.assign(
    {
      feature_filter_groups: undefined,
      page: 1,
      keyword: $stateParams.keyword || undefined,
    },
    overrides,
  );
}

export default class FeatureFilter extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const nextKey = filterKey(nextProps.featureFilter);

    if (nextKey !== prevState.appliedFilterKey) {
      return {
        appliedFilterKey: nextKey,
        groups: editorGroups(nextProps.featureFilter),
      };
    }

    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      groups: editorGroups(props.featureFilter),
      appliedFilterKey: filterKey(props.featureFilter),
      isOpen: false,
    };

    this.addRow = this.addRow.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.isApplyDisabled = this.isApplyDisabled.bind(this);
    this.updateGroup = this.updateGroup.bind(this);
    this.removeRow = this.removeRow.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  updateGroup(index, key, value) {
    const groups = this.state.groups.map((group, i) => {
      if (i !== index) {
        return group;
      }

      return normalizeGroup(Object.assign({}, group, { [key]: value }));
    });

    this.setState({ groups });
  }

  addRow() {
    this.setState({
      groups: this.state.groups.concat(emptyGroup()),
      isOpen: true,
    });
  }

  removeRow(index) {
    if (this.state.groups.length <= 1) {
      return;
    }

    this.setState({
      groups: this.state.groups.filter((_, i) => i !== index),
    });
  }

  isApplyDisabled() {
    return validGroups(this.state.groups).length === 0;
  }

  applyFilter() {
    if (this.isApplyDisabled()) {
      return;
    }

    return $state.go(
      "accounts",
      accountsListParams({
        feature_filter_groups: groupsToUrl(this.state.groups),
      }),
    );
  }

  clearFilter() {
    return $state.go("accounts", accountsListParams());
  }

  footerBtns() {
    const buttons = [
      {
        name: "Apply filter",
        preset: GECKO_CONSTS.BTN_PRESET_SAVE,
        secondary: true,
        disabledWhen: this.isApplyDisabled,
        handler: this.applyFilter,
      },
    ];

    if (hasActiveFeatureFilter(this.props.featureFilter)) {
      buttons.push({
        name: "Clear filter",
        preset: GECKO_CONSTS.BTN_PRESET_CLOSE,
        secondary: true,
        handler: this.clearFilter,
      });
    }

    return buttons;
  }

  toggleOpen() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  renderRows() {
    return this.state.groups.map((group, index) => (
      <React.Fragment key={index}>
        {index > 0 && <div className="featureFilter-between">And</div>}
        <FeatureFilterRow
          index={index}
          group={group}
          featureOptions={this.props.featureOptions}
          canRemove={this.state.groups.length > 1}
          onChange={this.updateGroup}
          onRemove={() => this.removeRow(index)}
        />
      </React.Fragment>
    ));
  }

  render() {
    const isOpen = this.state.isOpen;
    const summary = filterSummary(
      isOpen ? { groups: this.state.groups } : this.props.featureFilter,
    );

    return (
      <GeckoCardWrapper className="mb-3 featureFilter-panel">
        <div
          className="featureFilter-panel-header gecko-ui-card-header card-header p-3 border-bottom"
          onClick={this.toggleOpen}
        >
          <h2 className="header-title mb-0 featureFilter-panel-title">
            <GeckoIcon
              icon={isOpen ? "chevron-up" : "chevron-down"}
              className="featureFilter-chevron"
            />
            <span>Filter by feature</span>
            {summary && (
              <span className="featureFilter-summary">{summary}</span>
            )}
          </h2>
        </div>
        {isOpen && (
          <GeckoCardBody padded>
            {this.renderRows()}
            <div className="featureFilter-add">
              <GeckoBtn
                name="Add filter"
                className="btn-default"
                handler={this.addRow}
              />
            </div>
            <div className="featureFilter-actions">
              <GeckoBtnsSorted items={this.footerBtns()} />
            </div>
          </GeckoCardBody>
        )}
      </GeckoCardWrapper>
    );
  }
}
